import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import QuestionEdit from "../../student/goalquestions/questionedit";
import { getStudentIdData as getStudentGoalData } from "../../../lib/studentgoalquestion";
import { getDataWithType } from "../../../lib/parameters";

export default function GlobalGoalQuestions({ slug }) {
  const [questionlist, setQuestionlist] = useState([]);
  const [studentQuestionList, setStudentQuestionList] = useState([]);
  const [newAnswer, setNewAnswer] = useState();
  const [collapseAll, setCollapseAll] = useState(true);
  const collapseRefs = useRef([]);

  const navigate = useNavigate();
  // let { slug } = useParams();

  function getStudentData(qid) {
    if (studentQuestionList.length > 0) {
      const result = studentQuestionList.find(
        (item) => item.questionId === qid
      );
      return result ? result.id : 0;
    } else {
      return 0;
    }
  }

  function getStudentAnswer(qid) {
    if (studentQuestionList.length > 0) {
      const result = studentQuestionList.find(
        (item) => item.questionId === qid
      );
      return result ? result.studentAnswer : "";
    } else {
      return "";
    }
  }

  async function GetStudentGoalQuestionData() {
    const questions = await getDataWithType("STUDENTGOALQUESTION");
    setQuestionlist(questions);
    const stdquest = await getStudentGoalData(slug);
    setStudentQuestionList(stdquest);
    console.log("questions", questions);
    console.log("stdquest", stdquest);
  }

  useEffect(() => {
    console.log("new answer", newAnswer);
    GetStudentGoalQuestionData();
  }, [newAnswer]);

  useEffect(() => {
    GetStudentGoalQuestionData();
  }, []);

  const handleToggleAll = () => {
    collapseRefs.current.forEach((ref) => {
      const collapseInstance = new window.bootstrap.Collapse(ref, {
        toggle: false,
      });
      if (collapseAll) {
        collapseInstance.show();
      } else {
        collapseInstance.hide();
      }
    });
    setCollapseAll(!collapseAll);
  };

  return (
    <>
      {/* Goal Settings*/}
      <div className="col-xl-12 col-md-12">
        <div className="settings-widget profile-details">
          <div className="settings-inner-blk p-0">
            <div className="profile-heading d-flex justify-content-between">
              <h3>Goal Setting Survey</h3>
              <button
                className="btn btn-outline-info"
                onClick={handleToggleAll}
              >
                {collapseAll ? "Expand All" : "Collapse All"}
              </button>
            </div>
            <div className="comman-space pb-0">
              <div className="settings-invoice-blk table-responsive">
                {/* Invoice info */}
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Question</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {questionlist.map((data, ix) => (
                      <React.Fragment key={data.questionId}>
                        <tr>
                          <td className="p-2">{data.pname}</td>
                          <td className="text-center">
                            <button
                              type="button"
                              className="btn btn-outline-info"
                              onClick={() => {
                                const collapseInstance =
                                  new window.bootstrap.Collapse(
                                    collapseRefs.current[ix],
                                    {
                                      toggle: false,
                                    }
                                  );
                                collapseInstance.toggle();
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-arrows-angle-expand"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707"
                                />
                              </svg>
                            </button>
                          </td>
                        </tr>
                        <tr
                          className="collapse"
                          id={`collapseAnswer${ix}`}
                          ref={(el) => (collapseRefs.current[ix] = el)}
                        >
                          <td colSpan={2}>
                            <QuestionEdit
                              value={getStudentAnswer(data.id)}
                              setValue={setNewAnswer}
                              id={getStudentData(data.id)}
                              studentId={slug}
                              questionId={data.id}
                            />
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
                {/* Invoice info */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
